import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'app/components/common/icon';
import Popper from 'app/components/common/popper';

class DropdownButton extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {children, label, className, usePortal, left, icon: IconComp} = this.props;

    const popContent = (
      <div className="ddbtn-menu">
        {children}
      </div>
    );

    return (<>
      <Popper
        tagType="div"
        tabIndex="-1"
        className={`ddbtn-popper`}
        popType="menu"
        popContent={popContent}
        focusTrigger
        placement={left ? 'bottom-start' : 'bottom-end'}
        usePortal={usePortal}
      >
        <button className={`ddbtn-btn ${className}`}>{!!IconComp && <IconComp />}{label}<Icon.Caret direction="down" className="ddbtn-btn-caret" /></button>
      </Popper>
    </>);
  }

}

DropdownButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  usePortal: PropTypes.bool,
  left: PropTypes.bool,
};

DropdownButton.defaultProps = {
  className: '',
  children: null,
  usePortal: false,
  left: false,
};

export default DropdownButton;
